document.addEventListener("DOMContentLoaded", function () {
  const timer = document.getElementById("countdown-timer-2");
  if (!timer) return;

  const endTimestamp = parseInt(timer.dataset.endTime);
  if (!endTimestamp) return;

  function updateDisplay(ts) {
    const d = Math.floor(ts / 86400);
    const h = Math.floor((ts % 86400) / 3600);
    const m = Math.floor((ts % 3600) / 60);
    const s = ts % 60;

    document.getElementById("timer-days_2").textContent = String(d).padStart(2, "0");
    document.getElementById("timer-hours_2").textContent = String(h).padStart(2, "0");
    document.getElementById("timer-minutes_2").textContent = String(m).padStart(2, "0");
    document.getElementById("timer-seconds_2").textContent = String(s).padStart(2, "0");
  }

  function updateTimer() {
    const now = Math.floor(Date.now() / 1000);
    let remaining = endTimestamp - now;

    if (remaining <= 0) {
      updateDisplay(0);
      clearInterval(interval);
    } else {
      updateDisplay(remaining);
    }
  }

  updateTimer();
  const interval = setInterval(updateTimer, 1000);
});
